import { REACT_APP_BACKEND_URL } from "utils/secrets";

const envConfig = {
  BACKEND_URL: REACT_APP_BACKEND_URL,
};

export default envConfig;
